import { h } from './index-97874de0.js';
import { B as BaseButton } from './base-button-845f2463.js';

/*
 * SPDX-FileCopyrightText: 2023 Siemens AG
 *
 * SPDX-License-Identifier: MIT
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function BaseIconButton(props) {
    return h(BaseButton, Object.assign({}, props, { type: "button" }));
}

export { BaseIconButton as B };

//# sourceMappingURL=base-icon-button-38e2f6e6.js.map